import moment from "moment";
import React from "react";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import LiveMatchTracker from "../Score/ScoreBoard";
import { isEmpty, lowerCase, startCase } from "lodash";
import { formatNumber } from "../../Utils/Toast";
import SelectionHome from "./SelectionHome";
import Parlay from "./Parlay";

const ListingSportComp = ({
  heading,
  data,
  odds,
  type,
  handle,
  active,
  showAll,
  showScore,
  handleScore,
  activeFav,
  addToFavioute,
}) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  const scoreAll = useContextSelector(AuthContext, (ctx) => {
    return ctx.scoreAll;
  });
  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const navigate = useNavigate();

    const displayScore = (object) => {
    
    return object?.eventId && object?.eventId.toString().startsWith("-1") ? (
       <iframe
                  className="responsive-iframe w-100"
                  style={{
                    overflow: "hidden",
                   height: object?.screenScore === "full" ? "270px" : "141px",
                    backgroundColor: "#000000",
                    zIndex:"999",
                    position:`relative`,
                    width:`100%`
                  }}
                  id="scoreId"
                  src={object?.scoreURL}
                  onClick={() => console.log("User clicked on the iframe area!")}
                ></iframe>
    ) : (
       <iframe
                  className="responsive-iframe w-100"
                  style={{
                    overflow: "hidden",
                   height: object?.screenScore === "full" ? "270px" : "141px",
                    backgroundColor: "#000000",
                    zIndex:"999",
                    position:`relative`,
                    width:`100%`
                  }}
                  id="scoreId"
                  src={object?.scoreURL}
                  onClick={() => console.log("User clicked on the iframe area!")}
                ></iframe>
    );
  };
  return (
    <>
      {type == "all" && (
        <div
          data-v-3e8a2f82
          className="all-tab-title h-24 -mb-[3.14285714286rem]"
        >
          <div data-v-3e8a2f82 className="flex items-center p-2 py-9px">
            <div
              data-v-3e8a2f82
              className="w-1 h-5 bg-black ml-0.5 mr-3 rounded-sm"
            />
            <div
              data-v-3e8a2f82
              className="text-15 text-black font-bold leading-none flex-1"
            >
              {startCase(heading)}
            </div>
            <div
              onClick={() =>
                handle(lowerCase(heading), "", showAll == true ? false : true)
              }
              data-v-3e8a2f82
              className="sort-Filter inline-flex items-center justify-center bg-white text-11 cursor-pointer shadow-all-button bg-opacity-50 py-5px w-58px rounded-4px text-black-700"
            >
              <span data-v-3e8a2f82 className="mr-1">
                ALL
              </span>
              <i
                data-v-3e8a2f82
                className={`icon-arrow-double mt-px sm:mt-0 text-11 scale-75 transition-transform origin-center duration-300 transform ${
                  showAll ? "rotate-180" : ""
                } `}
              />
            </div>
          </div>
        </div>
      )}
      {data?.map((res) => {
        return (
          <div data-v-3e8a2f82 className="mb-2">
            <div
              onClick={() => handle(res?.gameType, res?.seriesId)}
              className="relative py-2 pr-12px pl-2 bg-secondary rounded-xl cursor-pointer transition-all duration-300 mx-2 rounded-t-xl rounded-b-none"
            >
              <h1 className="flex justify-start items-center text-base font-normal">
                <span className="w-27px h-5 p-1.5 mr-1 flex justify-center items-center rounded-[1.25rem] text-11 font-bold text-event-tab-num bg-event-tab-bg flex-shrink-0">
                  {res?.matchList?.length}
                </span>
                <span className="text-event-tab break-words mr-2">
                  {res?.seriesName}
                </span>
                <span
                  className={`icon-arrow-down-sencodary flex items-center text-12 h-21px ml-auto transition-transform origin-center duration-300 text-event-tab-icon transform ${
                    active?.includes(res?.seriesId) ? "rotate-180" : ""
                  } `}
                />
              </h1>
            </div>
            {active?.includes(res?.seriesId) &&
              res?.matchList?.map((item, index) => {
                let matchOdds = !parlay
                  ? odds?.find((res) => {
                      return res?.mi == item?.marketId;
                    }) || {}
                  : [];
                let show =
                  item?.runners?.length > 0 &&
                  item?.hasMatchOdds &&
                  !isEmpty(matchOdds) &&
                  !parlay;
                let animate = activeFav?.includes(item?.eventId);
                let scoreDisplay =
                  scoreAll?.length > 0
                    ? scoreAll?.find((obj) => {
                        return obj?.eventId == item?.eventId;
                      })
                    : {};
                return (
                  <div className="bg-black-100 overflow-hidden px-2">
                    <div className="vue-recycle-scroller ready page-mode direction-vertical">
                      <div
                        className="vue-recycle-scroller__item-wrapper"
                      >
                        <div
                          className="vue-recycle-scroller__item-view"
                          style={{
                            "-webkit-transform":
                              "translateY(0px) translateX(0px)",
                            "-ms-transform": "translateY(0px) translateX(0px)",
                            transform: "translateY(0px) translateX(0px)",
                          }}
                        >
                          {parlay ? (
                            <Parlay
                              index={index}
                              handleScore={handleScore}
                              showScore={showScore}
                              object={item}
                              odds={odds}
                              displayScore={displayScore}
                            />
                          ) : (
                            <div data-index={34708739}>
                              <div className="px-2 border-t border-solid border-black-100 bg-white competition-body">
                                <div
                                  onClick={() =>
                                    navigate(
                                      `/match-detail-velki/${item?.eventId}/${item?.marketId}`
                                    )
                                  }
                                  className="competition-main-row grid justify-center items-center gap-1 leading-17px py-10px"
                                >
                                  <div className="w-full h-full flex justify-center items-center -ml-1 scale-110">
                                    <div
                                      onClick={(e) => {
                                        if (item?.runners?.length > 0) {
                                          e.preventDefault();
                                          e.stopPropagation();
                                          addToFavioute(
                                            item?.eventId,
                                            "Match Odds",
                                            item?.marketId,
                                            item?.eventType
                                          );
                                        }
                                      }}
                                      data-v-117db823
                                      className="w-8 h-6 flex justify-center items-center"
                                      style={{
                                        "--b64d5fc0": "0.4363636363636363",
                                        "--3cad14f0": "-0.9375rem",
                                      }}
                                    >
                                      <div
                                        data-v-117db823
                                        className={`fave ${
                                          animate ? "animate" : ""
                                        } bg-star-sprit-black-webp`}
                                      />
                                    </div>
                                  </div>
                                  <div className="flex flex-col -ml-0.5">
                                    <div className="flex gap-2px justify-start items-center">
                                      <div className="flex justify-center items-center gap-2px">
                                        {" "}
                                        {item?.status == "in_play" && (
                                          <div className="icon-live">
                                            <img
                                              src="/assets/images/live.svg"
                                              alt="streaming"
                                              className="h-10px"
                                            />
                                          </div>
                                        )}

                                        {item?.hasFancy && (
                                          <div className="icon-fancybet">
                                            <img
                                              src={'/assets/images/fancybet.svg'}
                                              alt="fancybet"
                                              className="h-10px"
                                            />
                                          </div>
                                        )}
                                        {item?.hasBookmaker && (
                                          <div className="icon-bookmaker">
                                            <img
                                              src="/assets/images/bookmaker.svg"
                                              alt="bookmaker"
                                              className="h-10px"
                                            />
                                          </div>
                                        )}
                                        {/* {item?.hasSportBook && (
                                          <div className="icon-sportsbook">
                                            <img
                                              src="/assets/images/sportsbook.svg"
                                              alt="sportsbook"
                                              className="h-10px"
                                            />
                                          </div>
                                        )} */}
                                      </div>
                                      {item?.status == "in_play" ? (
                                        <div
                                          data-v-ef8204d4
                                          className="inline-flex items-center h-full"
                                          data-is-inplay-type="true"
                                          data-is-today-type="false"
                                          data-is-tomorrow-type="false"
                                        >
                                          <div data-v-ef8204d4 className>
                                            <div
                                              data-v-ef8204d4
                                              className="px-3px flex items-center justify-center bg-inPlay text-white font-bold text-8 leading-9px"
                                            >
                                              <span
                                                data-v-ef8204d4
                                                className="mt-1px"
                                              >
                                                In-Play
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          data-v-ef8204d4
                                          className="inline-flex items-center h-full"
                                          data-is-inplay-type="false"
                                          data-is-today-type="true"
                                          data-is-tomorrow-type="false"
                                        >
                                          <div data-v-ef8204d4 className>
                                            <div
                                              data-v-ef8204d4
                                              className="time-block flex items-center justify-center leading-9px"
                                              data-is-today-type="true"
                                              data-is-tomorrow-type="false"
                                            >
                                              <span
                                                data-v-ef8204d4
                                                className="text-submenu py-px text-center text-8 px-2px pb-0"
                                              >
                                                {isDateToday(
                                                  item?.eventDateTime
                                                )
                                                  ? "Today"
                                                  : moment(
                                                      item?.eventDateTime
                                                    ).format("DD/MM")}{" "}
                                                {moment(
                                                  item?.eventDateTime
                                                ).format("HH:MM")}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    <p className="text-black leading-16px text-13 break-words">
                                      {item?.eventName}
                                    </p>
                                  </div>
                                  <div className="flex justify-end items-center">
                                    {!isEmpty(scoreDisplay) && (
                                      <div className="whitespace-nowrap">
                                        <span className="pl-1 text-13 text-right text-warning font-bold">
                                          {scoreDisplay?.score}
                                        </span>
                                      </div>
                                    )}
                                    <i
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleScore(item?.scoreId);
                                      }}
                                      className={`ml-8px text-14 ${
                                        showScore?.includes(item?.scoreId)
                                          ? "icon-h2h-soild"
                                          : "icon-h2h"
                                      } `}
                                    />
                                    <i className="icon-arrow-down text-12 ml-2 text-black-500 -rotate-90" />
                                  </div>
                                </div>
                                {show && (
                                  <div className="pb-2">
                                    <div className="h-24px flex justify-between items-center rounded-t-md bg-primary border-b border-solid border-white">
                                      <div className="pl-2 w-9/12 flex items-center text-event-th border-r border-event-th-line leading-5">
                                        <span className="pr-2 text-13 font-bold">
                                          Match Odds
                                        </span>
                                        {item?.totalMatched > 0 && (
                                          <>
                                            <span className="pr-1 text-10">
                                              Matched
                                            </span>
                                            <span className="text-10 font-bold">
                                              {formatNumber(item?.totalMatched)}
                                            </span>{" "}
                                          </>
                                        )}
                                      </div>
                                      <div className="w-4/12 grid gap-0.5 grid-cols-2 text-10 leading-4 text-event-th-option text-center">
                                        <div className="min-w-min">Back</div>
                                        <div className="min-w-min">Lay</div>
                                      </div>
                                    </div>
                                    <SelectionHome
                                      matchOdds={matchOdds}
                                      object={item}
                                    />
                                  </div>
                                )}
                                {showScore?.includes(item?.scoreId) && (
                                  <div
                                    style={{ position: "relative" }}
                                    className="head-to-head-wrapper relative bg-LMT -mx-4 border-t-2 border-black-100 border-b"
                                  >
                                    <div
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleScore(item?.scoreId);
                                      }}
                                      data-v-70c0486c
                                      className="icon-close text-8 absolute top-7px right-5px z-10"
                                    />
                                    {displayScore({ object: item })}
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        );
      })}
    </>
  );
};

export default ListingSportComp;
